import { useQuery } from "@tanstack/react-query";
import adminApiClient from "../../../../api/admin";

const useUserProperties = (userId: string) => {
  return useQuery({
    queryKey: ["userProperties", userId],
    queryFn: () => adminApiClient.getUserProperties(userId),
  });
};

export default useUserProperties;
